<template>
  <div
      :is="bodyCategory + '-form'"
      v-model="data"
      :errors="errors"
      :company-id="companyId"
  />
</template>

<script>
import FactBoxForm from './FactBox.vue'
import GalleryForm from './Gallery.vue'
import ImageForm from './Image.vue'
import PodcastForm from './Podcast.vue'
import QuoteForm from './Quote.vue'
import SocialMediaForm from './SocialMedia.vue'
import TextForm from './Text.vue'
import VideoForm from './Video.vue'

export default {
  components: {FactBoxForm, GalleryForm, ImageForm, PodcastForm, QuoteForm, SocialMediaForm, TextForm,VideoForm},

  props: {
    bodyCategory: {
      required: true
    },

    value: {
      required: true
    },

    errors: {
      required: true
    },

    companyId: {
      required: false,
    },
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
